<template></template>

<script>
import { getServerSSOInfo, loginSso, putServerSSOInfo } from '@/api/common/login'
import { getToken, setToken } from '@/utils/token'
import store from '@/store'

export default {
  name: 'Sso',
  created() {
    loginSso().then(response => {
      console.log('sso')
      setToken(response.headers['x-auth-token'])
      // Token 값을 기준으로 로그인 여부를 확인한다.
      // Store에 토큰 값이 없으면 로그인 화면으로 이동한다.
      // 참고: 토큰 값은 쿠키에 저장됨
      let token = getToken()
      console.log('token : ' + token)
      if (!token) {
        location.reload()
        return
      }

      // 새로 화면이 불러오면 user Info 정보를 가져온다.
      // (토큰 값이 있어도 조회가 안될 수 있는 경우) request 상위에서 에러가 발생하면 무시된다.
      store.dispatch('SetUserInfo').then(() => {
        // user 정보를 가져온 이후에 이동 및 메뉴 적용
        console.log('setUserinfo')
        this.$store.dispatch('GetMenus')
        this.$store.dispatch('GetMyMenu', this.$store.state.user.userId)
        this.$router.replace('/')
        // 로그인 화면에서 바디 스크롤을 막아주는 클래스 지우기
        let bodyElement = document.getElementById('app')
        bodyElement.classList.remove('not_scroll')
        getServerSSOInfo().then(res => {
          console.log('Success :: SSO Server Info')
          console.log(res)
        })
      })
    }).catch(reject => {
      putServerSSOInfo().then(res => {
        console.log('Fail :: PUT SSO Server Info Start')
        console.log(res)
        loginSso().catch(error => {
          console.log('SSO RETRY FAIL' + error)
          getServerSSOInfo().then(res => {
            console.log('Fail :: SSO Server Info')
            console.log(res)
          })
        })
      })
      this.$router.replace('/')
    })
  }
}
</script>
